module.exports = __webpack_public_path__ + "static/media/banner_claro_flex.be415046.png";